var map = {
	"./de.json": [
		23634,
		3634
	],
	"./en.json": [
		40502,
		502
	],
	"./es.json": [
		84268,
		4268
	],
	"./fr.json": [
		71463,
		1463
	],
	"./it.json": [
		82766,
		2766
	],
	"./nl.json": [
		30164,
		164
	],
	"./ru.json": [
		48879,
		8879
	],
	"./tr.json": [
		99681,
		9681
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16297;
module.exports = webpackAsyncContext;